var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 47,
    viewBox: "0 0 66 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1002 6.60002C56.1002 2.97001 53.1301 0 49.5001 0H39.6001V6.60002H49.5001V15.345L38.0161 29.7001H26.4001V13.2H13.2C5.90702 13.2 0 19.1071 0 26.4001V36.3001H6.60002C6.60002 41.7781 11.022 46.2001 16.5 46.2001C21.9781 46.2001 26.4001 41.7781 26.4001 36.3001H41.1841L56.1002 17.6551V6.60002ZM16.5 39.6001C14.685 39.6001 13.2 38.1151 13.2 36.3001H19.8001C19.8001 38.1151 18.3151 39.6001 16.5 39.6001Z",
    fill: "#E8450A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89941 3.30078H26.3995V9.9008H9.89941V3.30078ZM56.0995 26.4008C50.6215 26.4008 46.1995 30.8229 46.1995 36.3009C46.1995 41.7789 50.6215 46.2009 56.0995 46.2009C61.5776 46.2009 65.9996 41.7789 65.9996 36.3009C65.9996 30.8229 61.5776 26.4008 56.0995 26.4008ZM56.0995 39.6009C54.2845 39.6009 52.7995 38.1159 52.7995 36.3009C52.7995 34.4859 54.2845 33.0009 56.0995 33.0009C57.9145 33.0009 59.3995 34.4859 59.3995 36.3009C59.3995 38.1159 57.9145 39.6009 56.0995 39.6009Z",
    fill: "#E8450A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.eeeb08fd30a7d8fcc182cc59ea9a4203.svg";
export { ForwardRef as ReactComponent };